import React, {
  useCallback,
  useContext,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { TextField } from '@mui/material';

import FirebaseContext from '../../../../../context/FirebaseContext';
import useToast from '../../../../hooks/useToast';
import ConfirmDialog from '../../../ConfirmDialog';
import { cancelCalDotComMeeting } from '../../utils';

import { StyledText } from './styles';
import texts from './texts.json';

const CalDotComMeetingCancelModal = ({
  leadId,
  onClose,
  setLoading,
  onCancelBooking,
  userName,
}) => {
  const [reason, setReason] = useState('');

  const { showToast } = useToast();
  const { firebase: { remote } } = useContext(FirebaseContext);

  const onCancelMeeting = useCallback(async () => {
    setLoading(true);
    const { success, error } = await cancelCalDotComMeeting(remote, leadId, reason, userName);
    if (success) {
      showToast(texts.cancellationSuccess);
      onCancelBooking();
      onClose();
    } else {
      showToast(format(texts.cancellationError, { error }), { error: true });
    }
    setLoading(false);
  }, [
    showToast,
    leadId,
    reason,
    setLoading,
    onClose,
    remote,
    onCancelBooking,
    userName,
  ]);

  return (
    <ConfirmDialog
      isOpen
      onConfirm={onCancelMeeting}
      onCancel={onClose}
      confirmDisabled={!reason.trim()}
      dialogTexts={{
        title: texts.title,
        content: (
          <>
            <StyledText>{texts.content}</StyledText>
            <TextField
              fullWidth
              multiline
              rows={3}
              label={texts.reasonLabel}
              placeholder={texts.reasonPlaceholder}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              variant="outlined"
              size="small"
            />
          </>
        ),
        confirm: texts.saveButton,
        cancel: texts.close,
      }}
    />
  );
};

CalDotComMeetingCancelModal.propTypes = {
  leadId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  onCancelBooking: PropTypes.func,
  userName: PropTypes.string,
};

CalDotComMeetingCancelModal.defaultProps = {
  onCancelBooking: () => {},
  userName: '',
};

export default CalDotComMeetingCancelModal;
